import { GET_ALL_JOB, GET_APPLICATIONS_BY_JOB_ID, LOADING } from "./jobType";

const initialState: any = {
  data: [],
  jobData: null,
  loading: false,
};

export default function jobReducer(state = initialState, action: any) {
  switch (action.type) {
    case GET_ALL_JOB:
      return {
        ...state,
        data: action.payload,
      };
      case GET_APPLICATIONS_BY_JOB_ID:
            return {
              ...state,
              data: action.payload,
            };
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
 